import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCopy } from '@fortawesome/free-solid-svg-icons'

// Botón de copiar que confirma con "¡Copiado!" (ver useCopy).
const CopyButton = ({ copied, onClick, children }) => (
  <Button color={copied ? 'success' : 'falcon-default'} size="sm" onClick={onClick} className="text-nowrap">
    <FontAwesomeIcon icon={copied ? faCheck : faCopy} className="mr-1" />
    {copied ? '¡Copiado!' : children}
  </Button>
)

CopyButton.propTypes = { copied: PropTypes.bool, onClick: PropTypes.func.isRequired, children: PropTypes.node }

export default CopyButton
